// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { FileSnippetImageCropBuf } from '../file/file-snippet-image-crop-buf.js';
import { FileSnippetMediaSliceBuf } from '../file/file-snippet-media-slice-buf.js';
import { FileSnippetPageBuf } from '../file/file-snippet-page-buf.js';
import { FileSnippetTextSliceBuf } from '../file/file-snippet-text-slice-buf.js';


export class FileSnippetBuf {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):FileSnippetBuf {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsFileSnippetBuf(bb:flatbuffers.ByteBuffer, obj?:FileSnippetBuf):FileSnippetBuf {
  return (obj || new FileSnippetBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsFileSnippetBuf(bb:flatbuffers.ByteBuffer, obj?:FileSnippetBuf):FileSnippetBuf {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new FileSnippetBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

page(obj?:FileSnippetPageBuf):FileSnippetPageBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? (obj || new FileSnippetPageBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

mediaSlice(obj?:FileSnippetMediaSliceBuf):FileSnippetMediaSliceBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? (obj || new FileSnippetMediaSliceBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

textSlice(obj?:FileSnippetTextSliceBuf):FileSnippetTextSliceBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? (obj || new FileSnippetTextSliceBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

imageCrop(obj?:FileSnippetImageCropBuf):FileSnippetImageCropBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? (obj || new FileSnippetImageCropBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

static startFileSnippetBuf(builder:flatbuffers.Builder) {
  builder.startObject(4);
}

static addPage(builder:flatbuffers.Builder, pageOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, pageOffset, 0);
}

static addMediaSlice(builder:flatbuffers.Builder, mediaSliceOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, mediaSliceOffset, 0);
}

static addTextSlice(builder:flatbuffers.Builder, textSliceOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, textSliceOffset, 0);
}

static addImageCrop(builder:flatbuffers.Builder, imageCropOffset:flatbuffers.Offset) {
  builder.addFieldOffset(3, imageCropOffset, 0);
}

static endFileSnippetBuf(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

}
